/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AccountsRpc
 */

export let ComHubspotPiesyncBridgeModelsAccountAbstractAuthenticateNewAccountError;
(function (_ComHubspotPiesyncBridgeModelsAccountAbstractAuthenticateNewAccountError) {})(ComHubspotPiesyncBridgeModelsAccountAbstractAuthenticateNewAccountError || (ComHubspotPiesyncBridgeModelsAccountAbstractAuthenticateNewAccountError = {}));
export let ComHubspotPiesyncBridgeModelsAccountAbstractReauthenticateAccountError;
(function (_ComHubspotPiesyncBridgeModelsAccountAbstractReauthenticateAccountError) {})(ComHubspotPiesyncBridgeModelsAccountAbstractReauthenticateAccountError || (ComHubspotPiesyncBridgeModelsAccountAbstractReauthenticateAccountError = {}));
export const verifyAccountsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'verifyAccounts',
  auth: 'app',
  fingerprint: '-ORqsy_IY_lxRdEOGzF9bd_U_jl4AGso',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRemoteAccountRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getRemoteAccount',
  auth: 'app',
  fingerprint: 'l_9qiaJjpjRCLz0wYnVwJK9dLsYDa9F6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRemoteAccountsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getRemoteAccounts',
  auth: 'app',
  fingerprint: 'NnMFVxjQHq2EO3vmBB9duUKDpks6CVLS',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRemoteAccountBaseRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getRemoteAccountBase',
  auth: 'app',
  fingerprint: 'l_9qiaJjpjQyjI5ORhah169dLsYDa9F6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRemoteAccountBasesRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getRemoteAccountBases',
  auth: 'app',
  fingerprint: 'NnMFVxjQHq1R4kKyQsGDqEKDpks6CVLS',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteAccountRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'deleteAccount',
  auth: 'app',
  fingerprint: '9fOp5utrMMi00B7sPuqGXkT35UejmZpi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const refreshVerificationsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'refreshVerifications',
  auth: 'app',
  fingerprint: 'TY0NVWxKkV8NPYfeIvnyrSefKFTkASdU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAppAccountsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getAppAccounts',
  auth: 'app',
  fingerprint: '7Xspv62sv5tyK8tRowhDAnhXjEVTLr-Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAccountVerificationsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getAccountVerifications',
  auth: 'app',
  fingerprint: 'ZmlVusUtSOOi3cyvbON-7u3WoH4NdXbj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listDatasetParametersRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'listDatasetParameters',
  auth: 'app',
  fingerprint: 'QZUF09h2PKt8al_sO5AUuEuHZ0EBUhLr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchDatasetParameterValuesRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'fetchDatasetParameterValues',
  auth: 'app',
  fingerprint: 'thIaJD9V1a2_pb7L0A5smYK9MHaL65T4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDatasetParametersRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getDatasetParameters',
  auth: 'app',
  fingerprint: 'wGZFyCwzFMo6ZRx2guwTkKDOBzmrHy5g',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAvailablePartitionsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'getAvailablePartitions',
  auth: 'app',
  fingerprint: '2aGGZ3A_772s8ifWzKE6hjU-RzScQX1T',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const reauthenticateAccountRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'reauthenticateAccount',
  auth: 'app',
  fingerprint: 'Lgs6wnrPk_JCLz0wYnVwJOR7eQalPYiy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const authenticateNewAccountRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AccountsRpc',
  rpcName: 'authenticateNewAccount',
  auth: 'app',
  fingerprint: 'Pl6dTESQ6oVCLz0wYnVwJCGh1t1V2X2E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};